import RecentContent from "./RecentContent";
import AdvWidgetBannerList from "../banner/AdvWidgetBannerList";
import { useAdBanners } from "../../util/useAdBanners";
import { WriteMembership } from "./MembershipAside";
const FALLBACK_TOP_ASIDE_BANNER = [
	[
		{ src: '/static/img/banner/board/right/1-001.gif', to: 'https://open.kakao.com/o/slfmVBvi', target: '_blank' },
	],
	[
		{ src: '/static/img/banner/board/right/2-001.png', to: '/membership'},
	],
];

const FALLBACK_BOTTOM_ASIDE_BANNER = [
	[
		{ src: '/static/img/banner/board/right/3-001.png', to: 'http://pf.kakao.com/_QIxlTK/chat', target: '_blank' },
	],
	[
		{ src: '/static/img/banner/board/right/4-001.png', to: 'http://pf.kakao.com/_Izxnxgn/chat', target: '_blank' },
	],
];

const BoardAside = ({showMembership = false}) => {
    const { groups: topBanner } = useAdBanners('board_aside_top', { groups: FALLBACK_TOP_ASIDE_BANNER });
    const { groups: bottomBanner } = useAdBanners('board_aside_bottom', { groups: FALLBACK_BOTTOM_ASIDE_BANNER });
    const displayTop = topBanner?.length ? topBanner : FALLBACK_TOP_ASIDE_BANNER;
    const displayBottom = bottomBanner?.length ? bottomBanner : FALLBACK_BOTTOM_ASIDE_BANNER;

    return (
        <aside className="vh-content-aside">
			<AdvWidgetBannerList bannerGroups={displayTop} ratio="1.7/1" />
			{ showMembership && <WriteMembership customStyle={{marginBottom:0}} />}
			<RecentContent />
			<AdvWidgetBannerList bannerGroups={displayBottom} ratio="1.7/1" />
        </aside>
    )
}

export default BoardAside;
